import { apiService } from './api';
import { Expense, CreateExpenseData, UpdateExpenseData, ExpenseSummary, ApiResponse } from '../types';

export const expenseService = {
  async getExpenses(params?: {
    date?: string;
    month?: string;
    year?: string;
    type?: string;
    start_date?: string;
    end_date?: string;
  }): Promise<ApiResponse<Expense[]>> {
    const queryParams = new URLSearchParams();
    if (params?.date) queryParams.append('date', params.date);
    if (params?.month) queryParams.append('month', params.month);
    if (params?.year) queryParams.append('year', params.year);
    if (params?.type) queryParams.append('type', params.type);
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    
    const queryString = queryParams.toString();
    const url = `/api/expenses${queryString ? `?${queryString}` : ''}`;
    return apiService.get<Expense[]>(url);
  },

  async getExpense(expenseId: number): Promise<ApiResponse<Expense>> {
    return apiService.get<Expense>(`/api/expenses/${expenseId}`);
  },

  async createExpense(expenseData: CreateExpenseData): Promise<ApiResponse<Expense>> {
    return apiService.post<Expense>('/api/expenses', expenseData);
  },

  async updateExpense(expenseId: number, expenseData: UpdateExpenseData): Promise<ApiResponse<Expense>> {
    return apiService.put<Expense>(`/api/expenses/${expenseId}`, expenseData);
  },

  async deleteExpense(expenseId: number): Promise<ApiResponse<void>> {
    return apiService.delete<void>(`/api/expenses/${expenseId}`);
  },

  async getDailyExpenses(date: string): Promise<ApiResponse<{
    date: string;
    expenses: Expense[];
    total: number;
    count: number;
  }>> {
    return apiService.get(`/api/expenses/daily/${date}`);
  },

  async getMonthlyExpenses(year: number, month: number): Promise<ApiResponse<{
    year: number;
    month: number;
    expenses: Expense[];
    total: number;
    count: number;
    daily_totals: { [key: string]: number };
  }>> {
    return apiService.get(`/api/expenses/monthly/${year}/${month}`);
  },

  async getYearlyExpenses(year: number): Promise<ApiResponse<{
    year: number;
    expenses: Expense[];
    total: number;
    count: number;
    monthly_totals: { [key: number]: number };
  }>> {
    return apiService.get(`/api/expenses/yearly/${year}`);
  },

  async getExpenseSummary(params?: {
    start_date?: string;
    end_date?: string;
  }): Promise<ApiResponse<ExpenseSummary>> {
    const queryParams = new URLSearchParams();
    if (params?.start_date) queryParams.append('start_date', params.start_date);
    if (params?.end_date) queryParams.append('end_date', params.end_date);
    
    const queryString = queryParams.toString();
    const url = `/api/expenses/summary${queryString ? `?${queryString}` : ''}`;
    return apiService.get<ExpenseSummary>(url);
  },
};

